import lozad from 'lozad';

export default {
  init() {
    // Toggle nav icon
    $('.nav-toggle').click(function() {
      $('.nav-toggle i').toggleClass('fa-bars fa-times');
    });

    $('#nav-primary').on('hidden.bs.modal', function() {
      $('.nav-toggle i').removeClass('fa-times').addClass('fa-bars');
    })

    // Lazy load images
    const observer = lozad('.lozad', {
      rootMargin: '250px 0px',
      threshold: 0.1,
      load: function(el) {
        el.src = el.dataset.src;

        // Load all carousel images
        if ($(el).parent().parent().hasClass('blog-list-item')) {
          $('.blog-list-item img:not([src])').each(function() {
            $(this).attr('src', $(this).data('src'));
          });
        }
      },
    });
    observer.observe();

    // Enable tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // Add body class if someone is using a touch device
    window.addEventListener('touchstart', function onFirstTouch() {
      $('body').addClass('user-is-touching');

      window.removeEventListener('touchstart', onFirstTouch, false);
    }, false);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js